import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Form, Button } from "react-bootstrap";
import Axios from "axios";

//COMPONENTS
import UploadComponent from "../../../../mainStyle/components/uploadComponent/config";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as ConfigStyles from "./styles";

function Config() {
    const dispatch = useDispatch();

    const [data, setData] = useState({
        homeImage: "",
        meetTheTeamImage: "",
        servicesAndEventsImage: "",
        communityImage: "",
        linksImage: "",
        contactUsImage: ""
    });

    const [buttonColor, setButtonColor] = useState("primary");

    const fileDetails = {
        fileSize: 8,
        fileMessage: "Images only"
    };

    const maxLength = 25;

    useEffect(() => {
        dispatch(GS_navSettingsActions.UpdateTitle("Style Configuration - Sections' Backgrounds"));
        onLoad();
    }, []);

    function onLoad() {
        Axios.post("/style/STYLE_SECIONSBACKGROUNDS_ADAMIN/load")
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    const temp = {
                        homeImage: data.info.homeImage,
                        meetTheTeamImage: data.info.meetTheTeamImage,
                        servicesAndEventsImage: data.info.servicesAndEventsImage,
                        communityImage: data.info.communityImage,
                        linksImage: data.info.linksImage,
                        contactUsImage: data.info.contactUsImage
                    };
                    setData(temp);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleNexFunction(reCallData, file) {
        const data = { file: file, deleteFile: reCallData.deleteFile, sectionImage: reCallData.sectionImage };
        Axios.post("/style/STYLE_SECIONSBACKGROUNDS_ADAMIN/nextFunction", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    onLoad();
                }
            })
            .catch((err) => console.log(err));
    }

    function handleTextChange(event) {
        const { name, value } = event.target;

        const temp = { ...data };

        temp[name] = value;

        setData(temp);
    }

    function handleActiveChange(event) {
        const { name, checked } = event.target;

        setData((prevState) => {
            return { ...prevState, [name]: checked };
        });
    }

    return (
        <div style={ConfigStyles.body}>
            <br />
            <Row>
                <Col>
                    <div style={ConfigStyles.textColumns}>Home</div>
                </Col>
                <Col style={ConfigStyles.textColumns}>
                    <UploadComponent
                        isImage={true}
                        fileType={"n/a"}
                        fileLimit={1}
                        fileSize={fileDetails.fileSize}
                        multiple={false}
                        reCallData={{ sectionImage: "homeImage", deleteFile: data.homeImage }}
                        directoryPath={"mainStyle/sectionsBackgrounds"}
                        nextFunction={handleNexFunction}
                        fileMessage={fileDetails.fileMessage}
                    />
                    {data.homeImage.replace("_", " ")}
                </Col>
                <Col></Col>
            </Row>
            <br />
            <Row>
                <Col>
                    <div style={ConfigStyles.textColumns}>Meet The Team</div>
                </Col>
                <Col style={ConfigStyles.textColumns}>
                    <UploadComponent
                        isImage={true}
                        fileType={"n/a"}
                        fileLimit={1}
                        fileSize={fileDetails.fileSize}
                        multiple={false}
                        reCallData={{ sectionImage: "meetTheTeamImage", deleteFile: data.meetTheTeamImage }}
                        directoryPath={"mainStyle/sectionsBackgrounds"}
                        nextFunction={handleNexFunction}
                        fileMessage={fileDetails.fileMessage}
                    />
                    {data.meetTheTeamImage.replace("_", "")}
                </Col>
                <Col></Col>
            </Row>
            <br />
            <Row>
                <Col>
                    <div style={ConfigStyles.textColumns}>Services and Events</div>
                </Col>
                <Col style={ConfigStyles.textColumns}>
                    <UploadComponent
                        isImage={true}
                        fileType={"n/a"}
                        fileLimit={1}
                        fileSize={fileDetails.fileSize}
                        multiple={false}
                        reCallData={{ sectionImage: "servicesAndEventsImage", deleteFile: data.servicesAndEventsImage }}
                        directoryPath={"mainStyle/sectionsBackgrounds"}
                        nextFunction={handleNexFunction}
                        fileMessage={fileDetails.fileMessage}
                    />
                    {data.servicesAndEventsImage.replace("_", "")}
                </Col>
                <Col></Col>
            </Row>
            <br />
            <Row>
                <Col>
                    <div style={ConfigStyles.textColumns}>Community</div>
                </Col>
                <Col style={ConfigStyles.textColumns}>
                    <UploadComponent
                        isImage={true}
                        fileType={"n/a"}
                        fileLimit={1}
                        fileSize={fileDetails.fileSize}
                        multiple={false}
                        reCallData={{ sectionImage: "communityImage", deleteFile: data.communityImage }}
                        directoryPath={"mainStyle/sectionsBackgrounds"}
                        nextFunction={handleNexFunction}
                        fileMessage={fileDetails.fileMessage}
                    />
                    {data.communityImage.replace("_", "")}
                </Col>
                <Col></Col>
            </Row>
            <br />
            <Row>
                <Col>
                    <div style={ConfigStyles.textColumns}>Links</div>
                </Col>
                <Col style={ConfigStyles.textColumns}>
                    <UploadComponent
                        isImage={true}
                        fileType={"n/a"}
                        fileLimit={1}
                        fileSize={fileDetails.fileSize}
                        multiple={false}
                        reCallData={{ sectionImage: "linksImage", deleteFile: data.linksImage }}
                        directoryPath={"mainStyle/sectionsBackgrounds"}
                        nextFunction={handleNexFunction}
                        fileMessage={fileDetails.fileMessage}
                    />
                    {data.linksImage.replace("_", "")}
                </Col>
                <Col></Col>
            </Row>
            <br />
            <Row>
                <Col>
                    <div style={ConfigStyles.textColumns}>Contact Us</div>
                </Col>
                <Col style={ConfigStyles.textColumns}>
                    <UploadComponent
                        isImage={true}
                        fileType={"n/a"}
                        fileLimit={1}
                        fileSize={fileDetails.fileSize}
                        multiple={false}
                        reCallData={{ sectionImage: "contactUsImage", deleteFile: data.contactUsImage }}
                        directoryPath={"mainStyle/sectionsBackgrounds"}
                        nextFunction={handleNexFunction}
                        fileMessage={fileDetails.fileMessage}
                    />
                    {data.contactUsImage.replace("_", "")}
                </Col>
                <Col></Col>
            </Row>
        </div>
    );
}

export default Config;
